import React, { useEffect, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import dynamic from 'next/dynamic';
import {
    faClock,
    faFile,
    faGlobe,
    faCalendarDays
} from '@fortawesome/free-solid-svg-icons';
import * as Yup from 'yup'
import Moment from 'react-moment'
import Link from 'next/link'
const CallBackForm = dynamic(() => import('../Common/CallBackForm', { ssr: false }));


export default function ContentSection({ data = null, page_name = "Common Page", form_name = "common-form", endpoint = "", isMobile = false, slug = null }) {
    const [scrolled, setScrolled] = useState(0)
    const [scrolledStatus, setScrolledStatus] = useState(false)
    useEffect(() => {
        const onScroll = () => setScrolled(window.pageYOffset);
        window.removeEventListener('scroll', onScroll);
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);

    }, []);
    const options = {
        btn_name: "Submit Your Request",
        btnCustomClass: "block mx-auto delve-bg-primary px-6 py-4 uppercase text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
    }

    useEffect(() => {
        if (scrolled > 30) {
            setScrolledStatus(true)
        }
    }, [scrolled])


    const fields = [
        {
            name: 'name',
            label: '',
            placeholder: "Name",
            validation: Yup.string().matches(/^[a-zA-Z\s]*$/, 'Name can only contain letters and spaces').required('Name is required'),
            customClass: 'md:col-span-6 col-span-12'
        },
        {
            name: 'email',
            type: 'email',
            label: '',
            placeholder: "Type your Email",
            validation: Yup.string().email('Invalid email').required('Email is required'),
            customClass: 'md:col-span-6 col-span-12'
        },
        {
            name: 'alternate_email',
            type: 'email',
            label: '',
            placeholder: "Alternate Email(Optional)",
            validation: Yup.string().email('Invalid email'),
            customClass: 'md:col-span-6 col-span-12'
        },
        {
            name: 'phone',
            label: '',
            placeholder: "Phone Number",
            validation: Yup.string(),
            customClass: 'md:col-span-6 col-span-12'
        },
        {
            name: 'message',
            label: '',
            placeholder: "Message",
            type: 'textarea',
            customClass: 'md:col-span-12 col-span-12 mb-5',
            col_row: 4
        },
    ];
    const printGeographies = (geographies) => {
        let geo = "";
        let eu4_uk = "";
        geographies?.map((data, index) => {
            if (data.value != "7MM[US ,EU5(Italy ,Spain ,UK ,Germany & France) and Japan]" && data.value != "7MM[US ,EU4(Italy ,Spain ,Germany & France) & UK and Japan]") {
                if(data.value === "EU4 & UK"){
                    eu4_uk = data.value;
                }else{
                    geo = geo + " " + data.value + ","
                }
            }
        });
        geo = geo + " " + eu4_uk + ","
        var trim = geo.replace(/(^,)|(,$)/g, "")
        return trim;
    }
    const getImageSource = (data) => {
        if (data?.infographics?.image) {
            return process.env.IMG_CDN + data?.infographics?.image;
        } else {
            if (data?.reports?.industries[0]?.value == 'Medical Devices') {
                return process.env.IMG_CDN + 'products/infographics/key-report%20features.png';
            } else {
                switch (data?.reports?.categories[0]?.value) {
                    case "Medical Devices":
                        return process.env.IMG_CDN + 'img/report-store/png/Medical-device-Infograph.jpg';
                    case "Market Insight":
                        return process.env.IMG_CDN + 'img/report-store/png/market-report-sample-page.png';
                    case "Pipeline Insight":
                        return process.env.IMG_CDN + 'img/report-store/png/Pipeline-Info.jpg';
                    case "Mechanism of Action Insight":
                        return process.env.IMG_CDN + 'img/report-store/png/MOA-Info.png';
                    case "Biosimilars":
                        return process.env.IMG_CDN + 'img/report-store/png/Biosimilars-Info-blue.jpg';
                    case "Drug Insight and Market Forecast":
                        return process.env.IMG_CDN + 'img/report-store/png/Emerging-Drug-Insight-And-Market-Forecast--Info.jpg';
                    default:
                        return process.env.IMG_CDN + 'img/report-store/png/infographics-market.png';
                }
            }
        }
    };


    return (
        <>
            <div className='mb-8'>
                <div className='flex lg:flex-row flex-col justify-between text-[24px] font-semibold mb-4'>
                    <h1 className='text-[#1b5df3]'>{(data?.samplePage?.page_title) != null ? <>{data?.samplePage?.page_title}</> : data?.reports?.name}</h1>
                    <div>
                        <Link href={process.env.APP_URL + "/report-store/" + data?.reports?.slug}>
                            <button className="bg-[#1b5df3] hover:bg-[#1b5df3] hover:text-white text-white font-semibold py-2 px-6 rounded text-sm">
                                VIEW REPORT
                            </button>
                        </Link>
                    </div>
                </div>
                <div className='flex flex-col lg:flex-row'>
                    <div className='flex items-center justify-between '>
                        <div className='flex items-center font-semibold'><FontAwesomeIcon className='text-[#1e5df3] pr-2' icon={faFile} /> Report Pages:</div>
                        <span className='pl-2 text-sm'>{data?.reports?.pages}</span>
                    </div>
                    <div className='flex items-center justify-between lg:px-12 lg:'>
                        <div className='flex items-center font-semibold'><FontAwesomeIcon className='text-[#1e5df3] pr-2' icon={faCalendarDays} /> Published Date:</div>
                        <span className='pl-2 text-sm'><Moment format='YYYY'>{data?.reports?.published_on}</Moment></span>
                    </div>
                    <div className='flex items-center justify-between lg:border-none'>
                        <div className='flex items-center font-semibold'><FontAwesomeIcon className='text-[#1e5df3] pr-2' icon={faGlobe} /> <span>Region:</span></div>
                        <span className='pl-2 text-sm font-semibold'>
                            {printGeographies(data?.reports?.geographies)}
                        </span>
                    </div>
                </div>
            </div>
            <div className='grid grid-cols-12 gap-4'>
                <div className='col-span-12 lg:col-span-6'>
                    {/* <div className='text-center py-2 font-semibold text-lg bg-[#1e5df3] text-white'>
                        <h2>Request for Free Sample Report</h2>
                    </div> */}
                    <h2 className='mb-4 text-xl font-semibold'>Request for Free Sample Report</h2>
                    <p className='mb-4 text-base'>Please provide your company email address so we can deliver sample pages to your inbox. If you don’t receive our email within a day, kindly check your spam folder and whitelist <a href={process.env.APP_URL} className='underline text-[#1b5df3]'>delveinsight.com</a>.</p>
                    <CallBackForm
                        fields={fields}
                        options={options}
                        page_name={page_name}
                        form_name={form_name}
                        product_name={data?.samplePage?.page_title}
                        endpoint={endpoint}
                        slug={data?.reports?.slug}
                    />
                        
                </div>
                <div className='col-span-12 lg:col-span-6'>
                    {(isMobile) ?
                        (scrolledStatus) &&
                        <div className='max-h-[575px] overflow-y-auto'>
                            <img src={getImageSource(data)} alt={data?.infographics?.image_alt || "sample page image"} width={2000} height={2000} className='w-full h-full' />
                        </div> :
                        <div className='max-h-[575px] overflow-y-auto'>
                            <img src={getImageSource(data)} alt={data?.infographics?.image_alt || "sample page image"} width={2000} height={2000} className='w-full h-full' />
                        </div>
                    }
                </div>
            </div>
        </>
    )
}
